import React, { useEffect, useState, lazy } from 'react';
import { Button, Row, Col } from "react-bootstrap";
import "../css/formacknowledgement.css";
import JsFileDownloader from 'js-file-downloader';
import { brokerFormOffline } from '../Utils/WHL/helpers';


/**
 * Acknowledgmenet screen which comes after a broker form is successfully submitted.
 */
const FormAcknowledgement = ({
    isFormSubmitSuccess
}) => {

    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        /** Remove displayed text after some time */
        if (success) {
            setTimeout(() => {
                setSuccess(false)
            }, 3000);
        }
        if (error) {
            setTimeout(() => {
                setError(false)
            }, 3000);
        }
    }, [success || error])

    return (
        <>
            <div className="broker-form-container fhaForm-ackmnt-container">
                {/* Hidden for now, enable if required */}
                {/* <div className='go-back' title="go back" onClick={() => { isFormSubmitSuccess(false) }}>
                    &#x2716;
                </div> */}
                <h4>
                    <p className='mb-2 inline-extra-padding'>Thank You!</p>
                    <p>You can download<br/>the Sun West broker application<br />from the link below.</p>
                </h4>
                <div className='btns-row'>
                    <Button className="btnSubmit btnSumbit-ack" type="submit"
                        onClick={
                            () => {
                                if (error) setError(false)

                                new JsFileDownloader({
                                    url: brokerFormOffline
                                })
                                    .then(function () {
                                        setSuccess(true)
                                    })
                                    .catch(function (error) {
                                        setError(true)
                                    });
                            }
                        }
                    >
                        Download
                    </Button>
                </div>
                {
                    success && <div className="success-div">Downloaded!</div>
                }
                {
                    error && <div className="error-div">Please try again</div>
                }
            </div>
        </>
    )
}

export default FormAcknowledgement